const SlackIntegrationLinkIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="33" height="33" viewBox="0 0 33 33" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11 19.5751C11 18.3067 12.0513 17.2856 13.3571 17.2856C14.663 17.2856 15.7143 18.3067 15.7143 19.5751V25.2105C15.7143 26.4788 14.663 27.4999 13.3571 27.4999C12.0513 27.4999 11 26.4788 11 25.2105V19.5751Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.575 21.9999C18.3067 21.9999 17.2856 20.9486 17.2856 19.6428C17.2856 18.3369 18.3067 17.2856 19.575 17.2856H25.2106C26.4789 17.2856 27.4999 18.3369 27.4999 19.6428C27.4999 20.9486 26.4789 21.9999 25.2106 21.9999H19.575Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.2856 7.78937C17.2856 6.52104 18.3369 5.5 19.6428 5.5C20.9486 5.5 21.9999 6.52104 21.9999 7.78937V13.4249C21.9999 14.6932 20.9486 15.7143 19.6428 15.7143C18.3369 15.7143 17.2856 14.6933 17.2856 13.4249V7.78937Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.78937 15.7143C6.52104 15.7143 5.5 14.663 5.5 13.3571C5.5 12.0513 6.52104 11 7.78937 11H13.4249C14.6932 11 15.7143 12.0513 15.7143 13.3571C15.7143 14.663 14.6933 15.7143 13.4249 15.7143H7.78937Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.2856 25.1428C17.2856 26.4486 18.3369 27.4999 19.6428 27.4999C20.9486 27.4999 21.9999 26.4486 21.9999 25.1428C21.9999 23.8369 20.9486 22.7856 19.6428 22.7856H17.2856V25.1428Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M25.1429 15.7143H22.7858V13.3571C22.7858 12.0513 23.8371 11 25.1429 11C26.4488 11 27.5001 12.0513 27.5001 13.3571C27.5001 14.663 26.4488 15.7143 25.1429 15.7143Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.85714 17.2856H10.2143V19.6428C10.2143 20.9486 9.163 21.9999 7.85714 21.9999C6.55129 21.9999 5.5 20.9486 5.5 19.6428C5.5 18.3369 6.55129 17.2856 7.85714 17.2856Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.7143 7.85714V10.2143H13.3571C12.0513 10.2143 11 9.163 11 7.85714C11 6.55129 12.0513 5.5 13.3571 5.5C14.663 5.5 15.7143 6.55129 15.7143 7.85714Z"
      fill="white"
    />
  </svg>
);

export const SlackIntegrationLink = ({ link }: { link?: string }) => {
  return link ? (
    <div className="flex items-center gap-2.5 mt-5">
      <div className="flex shrink-0">
        <SlackIntegrationLinkIcon />
      </div>
      <div className="text-nowrap">
        <a
          href={decodeURIComponent(link)}
          target={'_blank'}
          rel="noreferrer"
          className="font-semibold text-sm text-ebony_opacity_80 underline hover:text-ebony"
        >
          Integrate with Slack
        </a>
      </div>
    </div>
  ) : null;
};
